import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { DATE_FORMATS_FNS, ReactTable } from "components";
import { formatDate } from "utils/dateHelperFunctions";

export type LogsData = {
  time: string;
  user_name: string;
  affected_element: string;
  affected_element_id: string;
  description: string;
  user_id: string;
  appointment_id: string;
};

type LogsProps = {
  logs: LogsData[];
};

const columnHelper = createColumnHelper<LogsData>();

export const LogsTable = ({ logs }: LogsProps) => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      columnHelper.accessor(row => row, {
        id: "time",
        header: t("v8_time", "Time"),
        cell: ({ row: { original } }) => (original.time ? <div>{formatDate(original.time, DATE_FORMATS_FNS.dateMonthYearTime)}</div> : "")
      }),
      columnHelper.accessor(row => row, {
        id: "user_name",
        header: t("v8_user_name", "Name"),
        cell: ({ row: { original } }) => <div>{original.user_name}</div>
      }),
      columnHelper.accessor(row => row, {
        id: "affected_element",
        header: t("v8_affected_element", "Affected element"),
        cell: ({ row: { original } }) => <div>{original.affected_element}</div>
      }),
      columnHelper.accessor(row => row, {
        id: "description",
        header: t("v8_description", "Description"),
        size: 500,
        cell: ({ row: { original } }) => <div className="description">{original.description}</div>
      })
    ],
    [t]
  );

  return <ReactTable columns={columns} data={logs} />;
};
